import * as React from "react";
import { Snackbar, Alert } from "@mui/material";

/**
 * Hook for MUI Snackbar with success/error feedback.
 * Returns { snackbar, setSnackbar, showSuccess, showError, SnackbarComponent }.
 */
export function useSnackbar() {
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSuccess = React.useCallback((message) => {
    setSnackbar({ open: true, message, severity: "success" });
  }, []);

  const showError = React.useCallback((message) => {
    setSnackbar({ open: true, message: message || "An error occurred", severity: "error" });
  }, []);

  const handleClose = React.useCallback(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  const SnackbarComponent = React.useMemo(
    () =>
      React.createElement(
        Snackbar,
        {
          open: snackbar.open,
          autoHideDuration: 6000,
          onClose: handleClose,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        },
        React.createElement(Alert, {
          onClose: handleClose,
          severity: snackbar.severity,
          sx: { width: "100%" },
        }, snackbar.message)
      ),
    [snackbar.open, snackbar.message, snackbar.severity, handleClose]
  );

  return {
    snackbar,
    setSnackbar,
    showSuccess,
    showError,
    SnackbarComponent,
  };
}
